import CvcCard from './cvc-card'

export default CvcCard
